var map = {
	"./1x1.svg": "d0ef",
	"./1x2.svg": "5744",
	"./2x2.svg": "d21f",
	"./add.svg": "9354",
	"./alert-bell.svg": "9a9e",
	"./angle.svg": "d677",
	"./area.svg": "3e81",
	"./arrow-down.svg": "d351",
	"./arrow-left.svg": "c7cf",
	"./arrow-right.svg": "9459",
	"./arrow-top-left.svg": "62d3",
	"./arrow-top-right.svg": "12ca",
	"./arrow-up.svg": "233c",
	"./ascending.svg": "95ae",
	"./bell.svg": "f9f6",
	"./bill-glyph-16.svg": "4839",
	"./bill.svg": "2ea9",
	"./both-eyes.svg": "1a4b",
	"./bpm.svg": "9cff",
	"./building.svg": "8d13",
	"./calendar.svg": "430d",
	"./chart-primary.svg": "466c",
	"./check-glyph.svg": "818f",
	"./check-square.svg": "2abc",
	"./check.svg": "ef59",
	"./chevron-down.svg": "97ba",
	"./chevron-left.svg": "a66b",
	"./chevron-right.svg": "e905",
	"./chevron-up.svg": "3b83",
	"./circuit.svg": "0f1a",
	"./close.svg": "00c6",
	"./cloud-error.svg": "3405",
	"./cog.svg": "92f9",
	"./compare.svg": "b22c",
	"./crossroad.svg": "45ad",
	"./delete.svg": "8ae5",
	"./descending.svg": "fed8",
	"./download.svg": "91a4",
	"./edit.svg": "db15",
	"./filter.svg": "d0d9",
	"./group.svg": "cbe6",
	"./halt.svg": "eea5",
	"./inadequate.svg": "36a0",
	"./info.svg": "8e45",
	"./left-arrow.svg": "b980e",
	"./left-eye.svg": "6adc",
	"./lens-unavailable.svg": "bb48",
	"./link.svg": "160a",
	"./loader.svg": "74f4",
	"./loading-spinner-large.svg": "09c6",
	"./loading-spinner-small.svg": "e7d2",
	"./loading.svg": "df01",
	"./lock-2.svg": "b17a",
	"./lock.svg": "7d03",
	"./lungs.svg": "260e",
	"./maintenance.svg": "fa18",
	"./minus.svg": "e2a7",
	"./more.svg": "f916",
	"./myopia.svg": "6069b",
	"./nhs-logo.svg": "36db",
	"./no-roles.svg": "8ca0",
	"./note.svg": "aeca",
	"./org-unit.svg": "710d",
	"./outcome.svg": "5d79",
	"./pen.svg": "ca06",
	"./pin.svg": "453e",
	"./play.svg": "3e02",
	"./preferences1.svg": "c67b",
	"./primary-vector.svg": "ba41",
	"./refresh.svg": "1157",
	"./reload.svg": "8746",
	"./right-arrow.svg": "7ac9",
	"./right-eye.svg": "a8ff",
	"./right-vector-arrow.svg": "55b6",
	"./search.svg": "a4ef",
	"./section.svg": "b15f",
	"./signout.svg": "83a9",
	"./sortable.svg": "c7d9",
	"./support.svg": "b4ff",
	"./text.svg": "c7d96",
	"./tick.svg": "f47e",
	"./trash.svg": "cabd",
	"./undo.svg": "0edc",
	"./user-glyph-32.svg": "ae0a",
	"./user.svg": "0bf9",
	"./users-multiple.svg": "9c98",
	"./warning.svg": "2fa7",
	"./workstation.svg": "84ec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9f16";